//! This file is automatically generated by 'scripts/locales/generateI18nTypes.ts'
//! It should not be manually modified.

export const i18nNamespaces = [
  "accountSelection",
  "advancedSearch",
  "clipDetails",
  "clipTable",
  "collectionDetails",
  "common",
  "dashboard",
  "dynamicForm",
  "facetingPanel",
  "home",
  "login",
  "metadataEditor",
  "operations",
  "productionSelection",
  "send",
  "serviceOrders",
  "share",
  "smartPlayer",
  "table",
  "workflowTable"
]
